import "core-js/modules/es7.object.get-own-property-descriptors";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { console } from 'vuedraggable/src/util/helper';
import { refreshAuthApi } from '@/api/baseApp/user';
import { selectButtonWithAuthApi } from '@/api/baseApp/role';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/top-scientists', '/top-scientists-edit', '/sewageLogin', '/ssoLogin', '/authLogin', '/lsds/index', '/lsds/shop-area', '/auth-redirect', '/bind', '/stop-service/stop', '/stop-service/partone', '/stop-service/parttwo', '/mobile/inspect/outTaskList', '/mobile/inspect/viewDetails', '/mobile/inspect/rectificationReply', '/mobile/inspect/taskDetailOut', '/mobile/inspect/rectificationReview', '/sewage/sewageIndex', '/sewage/sewageDetail', '/sewageDataSetting', '/mobile/parking/open-visitor', '/mobile/annals/index', '/mobile/annals/startIndex', '/mobile/quarantine', '/quarantineLogin', '/mobile/quarantine/quarantineInfo', '/mobile/quarantine/quarantineUser', '/mobile/energyControl/index', '/mobile/meetingRoom/invitationCode', '/mobile/meetingRoom/appointInfo', '/mobile/appointInfo/registered', '/mobile/appointInfo/unregistered', '/mobile/appointInfo/exhibitionIndex', '/mobile/visitor/visitorRegistration', '/mobile/visitor/visitorByVerificationCodeDetail', '/mobile/visitor/createRegistrationCode', '/VVCode', '/mobile/visitor/registrationCode', '/mobile/visitor/visitorInformation', '/mobile/quarantine/monitorCode', '/mobile/boothConstruction/login', '/mobile/boothConstruction/outRectificationInformation', '/mobile/boothConstruction/outRectificationNotice', '/mobile/homeCourtSetup/rectifyAndReformList', '/mobile/boothConstruction/outRectificationReply', '/mobile/homeCourtSetup/menuBar', '/mobile/homeCourtSetup/summarySheetList', '/mobile/homeCourtSetup/rectificationSummary', '/mobile/homeCourtSetup/exhibitionInformation', '/mobile/homeCourtSetup/viewAll', '/mobile/homeCourtSetup/newExhibition', '/monitorRever', '/monitorSupervision', '/mobile/homeCourtSetup/rectificationAndPowerTransmission', '/conferenceRoom', '/conference', '/monitorJADYC', '/newMonitorJADYC', '/codeAdministration', '/videoWall', '/safetyProduction', '/mobile/wordExpo', '/monitorJADYCNorth', '/newMonitorJADYCNorth', '/videoWallNorth', '/safetyProductionNorth', '/xg/parking-visitor', 'xg/approval', '/mobile/dlgjtvisitor', '/mobile/detail', '/mobile/success', '/mobile/applyInfo', '/mobile/dlgexpregforzyy', '/mobile/dlgexpdetailforzyy', '/mobile/dlgexplistforzyy', '/mobile/dlgexpjoinforzyy', '/mobile/parking/open-home']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, acc, keys, i, key, value, hasRoles, _yield$store$dispatch, roleId, accessRoutes, quarantine;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          if (window.location.origin !== 'http://10.106.34.231') {
            document.title = getPageTitle(to, to.meta.title);
          }

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 54;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 12;
            break;
          }
          // if is logged in, redirect to the home page
          acc = {};
          keys = Object.keys(to.query);
          for (i = 0; i < keys.length; i++) {
            key = keys[i];
            value = to.query[key];
            if (key !== 'redirect') {
              acc[key] = value;
            }
          }
          next({
            path: to.query.redirect || '/',
            query: acc
          });
          NProgress.done();
          _context.next = 52;
          break;
        case 12:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 22;
            break;
          }
          if (!to.name) {
            _context.next = 19;
            break;
          }
          _context.next = 17;
          return refreshAuthApi({
            menusId: to.name
          });
        case 17:
          _context.next = 19;
          return selectButtonWithAuthApi({
            menusId: to.name
          }).then(function (res) {
            // store.dispatch('user/getButtonInfo', res.data)
            // store.dispatch('user/getButtonInfo', res.data)
            store.commit('user/SET_BUTTONS', res.data);
          });
        case 19:
          next();
          _context.next = 52;
          break;
        case 22:
          _context.prev = 22;
          _context.next = 25;
          return store.dispatch('user/getInfo');
        case 25:
          _yield$store$dispatch = _context.sent;
          roleId = _yield$store$dispatch.roleId;
          _context.next = 29;
          return store.dispatch('permission/generateRoutes', roleId);
        case 29:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          // 获取城市信息
          store.dispatch('baseApp/getCityAndWea').then(function () {});
          // 获取组织列表
          _context.next = 34;
          return store.dispatch('baseApp/getOrgMap');
        case 34:
          _context.next = 36;
          return store.dispatch('baseApp/getDataDicTree');
        case 36:
          // 获取人员结构
          store.dispatch('baseApp/getUserMap');
          // 获取人员应用
          _context.next = 39;
          return store.dispatch('baseApp/getUserApplication');
        case 39:
          _context.next = 41;
          return store.dispatch('baseApp/getSpaceMap');
        case 41:
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 52;
          break;
        case 44:
          _context.prev = 44;
          _context.t0 = _context["catch"](22);
          _context.next = 48;
          return store.dispatch('user/resetToken');
        case 48:
          Message.error(_context.t0 || 'Has Error');
          console.log(_context.t0);
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 52:
          _context.next = 66;
          break;
        case 54:
          if (!(whiteList.indexOf(to.path) !== -1)) {
            _context.next = 58;
            break;
          }
          // in the free login whitelist, go directly
          next();
          _context.next = 66;
          break;
        case 58:
          quarantine = sessionStorage.getItem('quarantineLogin');
          console.log(quarantine, 'quarantine');
          if (!(quarantine === '1')) {
            _context.next = 64;
            break;
          }
          next("/quarantineLogin?redirect=".concat(to.fullPath));
          NProgress.done();
          return _context.abrupt("return");
        case 64:
          // other pages that do not have permission to access are redirected to the login page.
          if (window.location.origin === 'http://10.106.34.231') {
            next("/ssoLogin?redirect=".concat(to.fullPath));
          } else {
            next("/login?redirect=".concat(to.fullPath));
          }
          NProgress.done();
        case 66:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[22, 44]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});